import { render, staticRenderFns } from "./StaffActiveSuccess.vue?vue&type=template&id=30f32c2b&scoped=true&"
import script from "./StaffActiveSuccess.vue?vue&type=script&lang=js&"
export * from "./StaffActiveSuccess.vue?vue&type=script&lang=js&"
import style0 from "./StaffActiveSuccess.vue?vue&type=style&index=0&id=30f32c2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f32c2b",
  null
  
)

export default component.exports